import Mock, { Random } from 'mockjs';
import MockRequest, { AjaxDate } from '../MockRequest';

export function queryQuestionModules(data: AjaxDate) {
  console.log(data);
  return new MockRequest(
    Mock.mock(
      {
        [`data|${Random.integer(1, 7)}`]: [{
          assignmentId: '@guid',
          id: '@guid',
          moduleName: '@cword(2,10)',
          seq: '@integer(0,7)',
        }],
      },
    ), '请求成功', true,
  );
}

export function delQuestionModule(data: AjaxDate) {
  const { ids } = JSON.parse(data.body);
  return new MockRequest(
    ids, '删除成功', true,
  );
}

export function test() { return {}; }
